import ucFirst from './util/ucFirst';

export default {
    productSearch: () => {
        const form = jQuery('section.product-search form');
        jQuery('select[name=make]', form).on('change', (event) => {
            jQuery('select[name=model]', form).val(0);
            jQuery.ajax(form.attr('action'), {
                data: {
                    slug: jQuery(event.currentTarget).val(),
                    action: 'product-search',
                },
                type: form.attr('method'),
                dataType: 'html',
                success: (data) => {
                    jQuery('select[name=model]', form).html(data);
                },
                error: (error) => {
                    console.log('Failed', error);
                },
            });
        });
        jQuery('select', form).on('change', () => {
            let str = '/product-category/';
            let active = true;
            jQuery('select', form).each((index, element) => {
                const item = jQuery(element);
                if ((String(item.val()) === '0' || item.val() === null || item.val() === undefined) && active) {
                    active = false;
                }
                str += `${item.val()}/`;
            });
            const button = jQuery('a.btn', form);
            if (active) {
                button.attr('href', str).removeClass('disabled');
            } else {
                button.attr('href', 'javascipt:void(0);').addClass('disabled');
            }
        });
    },
    campaignMonitor: () => {
        let $form = jQuery('form[data-campaign-monitor]');
        $form.find('button[type=submit] span').show();
        $form.find('button[type=submit] i.spinner').hide();
        $form.submit((event) => {
            event.preventDefault();
            $form = jQuery(event.currentTarget);
            const $input = $form.find('input[type=email]');
            $input.on('keypress', () => {
                $input.popover('dispose');
            });
            $form.find('button[type=submit] span').hide();
            $form.find('button[type=submit] i.spinner').show();
            $input.popover('dispose');
            jQuery.post($form.attr('action'), $form.serialize(), (data) => {
                $form.find('button[type=submit] span').show();
                $form.find('button[type=submit] i.spinner').hide();
                let _html = '';
                if (data.status === 'validation') {
                    _html = '<p>Please check that all fields are entered correctly.</p><ul>';
                    jQuery.each(data.data, (key, message) => {
                        const messageFormatted = message.replace('{{field}}', ucFirst(key.replace(new RegExp('_', 'g'), ' ')));
                        _html += `<li>${messageFormatted}</li>`;
                    });
                    _html += '</ul>';

                    $input.popover({
                        template: '<div class="popover form warning" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                        content: _html,
                        html: true,
                        placement: 'top',
                        title: '',
                        trigger: 'focus',
                        container: $form,
                    }).focus();
                } else if (data.status === 'success') {
                    _html = '<p>Thank you for signing up</p>';
                    $form.popover({
                        template: '<div class="popover form success" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                        content: _html,
                        html: true,
                        placement: 'top',
                        title: '',
                        trigger: 'manual',
                        container: $form,
                    }).popover('show');

                    setTimeout(() => {
                        $form.popover('dispose');
                    }, 2500);
                } else {
                    _html = '<p>An error occurred, please try again later</p>';
                    $form.popover({
                        template: '<div class="popover form error" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                        content: _html,
                        html: true,
                        placement: 'top',
                        title: '',
                        trigger: 'manual',
                        container: $form,
                    }).popover('show');

                    setTimeout(() => {
                        $form.popover('dispose');
                    }, 5000);
                }
            }, 'json');
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/app.js